import { useEffect } from "react";
import "./books.css";

function EbookBuys() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://gumroad.com/js/gumroad.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <div className="header-1">
        <a href="/" className="home-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#1f1f1f"
          >
            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
          </svg>
        </a>
        <h1 className="header">Guide</h1>
      </div>
      <div className="cover-container-">
        <img src="https://i.imgur.com/hukR75h.png" alt="" className="cover-" />
        <div className="cover-text-">
          <p className="cover-p-">
            A 29-page Jersey City guide covering dog training basics, finding
            trusted walkers and sitters, and the best dog-friendly cafés, parks,
            beaches, vets, groomers, and trainers.
          </p>
        </div>
      </div>
      <a
        href="https://zekeriyacnl.gumroad.com/l/afpxm?wanted=true"
        data-gumroad-overlay="true"
        className="ebook-button-"
      >
        Get the Guide
      </a>
    </div>
  );
}

export default EbookBuys;
